<template>
  <b-modal
    centered
    size="md"
    :visible="show"
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-container fluid>
      <b-row>
        <b-col>
          <h4 class="text-info m-2">{{ order_item_name }}:</h4>
          <h5 class="text-secondary m-2">
            {{ $t("globals.change_price_from") + ": " + order_item_price }}
          </h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <label class="m-2">{{ $t("globals.new_price") }}:</label>
        </b-col>
        <b-col>
          <b-input
            class="m-2"
            v-model.number="new_order_item_price"
            type="text"
          >
          </b-input>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col>
          <b-btn
            style="float: right; margin: 0.3em;"
            @click="save"
            variant="success"
            :disabled="saveDisabled"
          >
            {{ $t("globals.save") }}
          </b-btn>
          <b-btn
            style="float: left; margin: 0.3em;"
            @click="cancelModal"
            variant="warning"
          >
            {{ $t("globals.cancel") }}
          </b-btn>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    show: Boolean,
    close: Function,
    order_item_id: String,
    order_item_price: Number,
    order_item_name: String
  },
  data() {
    return {
      new_order_item_price: null
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation"]),
    save() {
      let data = {
        query: `
          mutation { 
            res: OrderItemUpdatePrice (
              order_item_id: ${parseInt(this.order_item_id)},
              new_price: ${parseInt(this.new_order_item_price)}
            )
          }
        `
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.cancelModal();
      });
    },
    cancelModal() {
      this.new_order_item_price = null;
      this.close();
    }
  },
  computed: {
    saveDisabled: function() {
      return this.new_order_item_price == null || this.new_order_item_price < 1;
    }
  }
};
</script>
